import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import {
  AppBar,
  Grid,
  Toolbar,
  Typography,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

import logoTop from "../common/svgs/logoTop.svg";
import "./lotterySystem.css";

const LandingPageHeader: React.FC = () => {
  const { t } = useTranslation("translation");
  const navigate = useNavigate();
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md")); // Tablets (600px - 1024px)
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // Mobile (below 600px)

  const [drawerOpen, setDrawerOpen] = useState(false);

  const gotoScroll = (id: string) => {
    const target = document?.getElementById(id);
    const targetIds = ["features4", "about-us", "contact-us"];
    const windowScrollIds = ["lottery-display", "digital-signage", "pricing"];

    if (target && targetIds.includes(id)) {
      target.scrollIntoView({ behavior: "smooth" });
    } else if (windowScrollIds.includes(id)) {
      const offset = target?.offsetTop;
      const headerHeight = 110;
      if (offset) {
        window.scrollTo({
          top: offset - headerHeight,
          behavior: "smooth",
        });
      }
    } else {
      target?.scrollIntoView({ behavior: "smooth" });
    }
  };

  const menuItems = [
    { label: t("lotteryDisplay"), id: "lottery-display" },
    { label: t("features"), id: "features4" },
    { label: t("digitalSignage"), id: "digital-signage" },
    { label: t("pricing"), id: "pricing" },
    { label: t("aboutUs"), id: "about-us" },
    { label: t("contactUs"), id: "contact-us" },
  ];

  return (
    <AppBar className="landing-appbar" position="sticky">
      <Toolbar className="landing-logo" disableGutters>
        {/* Logo */}
        <img
          src={logoTop}
          onClick={() => gotoScroll("landing-intro")}
          alt="logo top"
          style={{
            cursor: "pointer",
            height: isMobile ? "45px" : isTablet ? "55px" : "95px",
            width: isMobile ? "110px" : isTablet ? "130px" : "180px",
            marginLeft: isMobile ? "10px" : "20px",
          }}
        />

        {/* Desktop Menu */}
        {!isTablet && !isMobile ? (
          <Grid container spacing={2}>
            <Grid
              item
              xs={11}
              display="flex"
              justifyContent="flex-end"
              alignItems="center"
            >
              {menuItems.map((item) => (
                <Typography
                  key={item.id}
                  className="landing-appbar-typo"
                  onClick={() => gotoScroll(item.id)}
                  sx={{
                    cursor: "pointer",
                    marginLeft: "20px",
                    fontSize: isTablet ? "1rem" : "1.2rem",
                  }}
                >
                  {item.label}
                </Typography>
              ))}
              <Typography
                className="login-appbar-typo white-bordered-text"
                onClick={() => navigate("/login")}
                sx={{
                  cursor: "pointer",
                  marginLeft: "20px",
                  fontSize: isTablet ? "1rem" : "1.2rem",
                }}
              >
                {t("loginMenuText")}
              </Typography>
            </Grid>
          </Grid>
        ) : (
          // Mobile & Tablet Menu (Hamburger Icon)
          <IconButton
            edge="end"
            color="inherit"
            aria-label="menu"
            onClick={() => setDrawerOpen(true)}
            sx={{ marginLeft: "auto", marginRight: "10px" }}
          >
            <MenuIcon />
          </IconButton>
        )}
      </Toolbar>

      {/* Mobile & Tablet Drawer */}
      <Drawer anchor="right" open={drawerOpen} onClose={() => setDrawerOpen(false)}>
        <List sx={{ width: "250px" }}>
          {menuItems.map((item) => (
            <ListItem button key={item.id} onClick={() => { gotoScroll(item.id); setDrawerOpen(false); }}>
              <ListItemText primary={item.label} />
            </ListItem>
          ))}
          <ListItem button onClick={() => { navigate("/login"); setDrawerOpen(false); }}>
            <ListItemText primary={t("loginMenuText")} />
          </ListItem>
        </List>
      </Drawer>
    </AppBar>
  );
};

export default LandingPageHeader;
